import { Enum, EnumType } from 'ts-jenum';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';

@Enum<AuthenticationStateEnum>('name')
export class AuthenticationStateEnum extends EnumType<AuthenticationStateEnum>() {
   static readonly UNKNOWN = new AuthenticationStateEnum('unknown', false, false, null, null);
   static readonly AUTHENTICATED = new AuthenticationStateEnum('authenticated', true, false, null, null);
   static readonly AUTHENTICATION_FAILURE = new AuthenticationStateEnum(
      'authentication-failure',
      false,
      true,
      WellKnownIconsEnum.ERROR.icon,
      'common.authentication.authentication_failure'
   );
   static readonly USER_LOCKED = new AuthenticationStateEnum('user-locked', false, true, WellKnownIconsEnum.ERROR.icon, 'common.authentication.user_locked');
   static readonly USER_NOT_ALLOWED = new AuthenticationStateEnum(
      'user-not-allowed',
      false,
      true,
      WellKnownIconsEnum.ERROR.icon,
      'common.authentication.user_not_allowed'
   );
   static readonly INVALID_CREDENTIALS = new AuthenticationStateEnum(
      'invalid-credentials',
      false,
      true,
      WellKnownIconsEnum.ERROR.icon,
      'common.authentication.invalid_credentials'
   );

   private constructor(
      public name: string,
      public authenticated: boolean,
      public showError: boolean,
      public errorIcon: IconDefinition,
      public errorText: string
   ) {
      super();
   }
}
